export const API_APP_URL = process.env.REACT_APP_API_URL;
export const API_CRM_URL = process.env.REACT_APP_CRM_API_URL;
export const API_APP_TEST_PORTAL_URL = process.env.REACT_APP_TEST_PORTAL_API_URL;
